import React from 'react';
import RightMenuIcon from '@mui/icons-material/KeyboardArrowLeft';
import { IconButton, Tooltip } from '@mui/material';

import { WalkthroughBlurbAnchor } from '@paragon/tour-guide';

import { useAppMonitor } from '../../../monitor';
import { toggleRightSidebarIfPossible } from '../../../store/actions/navigationPanelActions';
import { getRightSidebarInfo } from '../../../store/selectors/rightToolbarSelectors';
import { leftSidebarSet, rightToolBarShowSet } from '../../../store/slices/panelDataSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarBase } from './ToolbarBase';

interface Props {
  open: boolean;
  onMobile: boolean;
}

export function RightSidebarControlToolbar({ open, onMobile }: Props) {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const rightSidebar = useAppSelector(getRightSidebarInfo);

  return (
    <WalkthroughBlurbAnchor id="right-sidebar-control-button" blurbPlacement="right">
      <ToolbarBase orientation="horizontal" sx={{ marginRight: '-8px!important', marginTop: '8px!important' }}>
        <Tooltip disableInteractive title="Toggle Right Sidebar">
          <span>
            <IconButton
              size="small"
              disabled={open && !rightSidebar.canBeClosed}
              onClick={() => {
                monitor.recordInteraction('Toggle Right Sidebar button clicked', {
                  actionType: open ? 'close' : 'open',
                });
                if (open) {
                  dispatch(toggleRightSidebarIfPossible());
                } else {
                  dispatch(rightToolBarShowSet(true));
                }

                if (onMobile) dispatch(leftSidebarSet('closed'));
              }}
              id="toggle-right-sidebar-button"
              sx={[
                { border: 0, borderRadius: '5px' },
                open
                  ? {
                      transform: 'rotate(180deg)',
                    }
                  : null,
              ]}
            >
              <RightMenuIcon />
            </IconButton>
          </span>
        </Tooltip>
      </ToolbarBase>
    </WalkthroughBlurbAnchor>
  );
}
